import React, {Fragment, useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import {handleValidateObj} from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import {Button, Image} from "react-bootstrap";
import Images from "../../../assets/images/imageData";
import propTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { toast, ToastContainer } from "react-toastify";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import CardSection from 'components/sales/cardSection/cardSection';
import './hoto.css';

const HotoMainForm = ({
                        history,
                        getHotoMaterialList,
                        match,
                        hotoMaterialList,
                        imageUploadUrlPublic,
                        saveHotoMaintenance,
                        getHotoDetails,
                        hotoDetails,
                        getMaterial,
                        allMaterialList

                      }) => {

  const [inputList, setInputList] = useState([]);
  const [matData, setMatData] = useState();
  const [isTarget, setIsTarget] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalMsg,setMessage] = useState('');
  const { baseUrl } = useContext(BaseUrl);
  const [previousIter, setPreviousIter] = useState();
  const [iterCount, setIterCount] = useState();
  const [materialList, setMaterialList] = useState([]);
  const [addMaterialModal, setAddMaterialModal] = useState(false);
  const [newMaterial, setNewMaterial] = useState();

  useEffect(() => {
    if (
      hotoMaterialList?.prod_array !== undefined &&
      hotoMaterialList?.prod_array !== null
    ) {
      const matData = hotoMaterialList?.prod_array;

      setTimeout(() => {
        if (matData != '') {
          setInputList(matData);
        }
      }, 100);

    }
  }, [hotoMaterialList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getHotoDetails(match.params.id);
      setIsLoading(false)
    })()
  }, []);

  useEffect(() => {
    if (hotoDetails && hotoDetails?.prevIter) {
      setPreviousIter(hotoDetails?.prevIter);
      setIterCount(hotoDetails?.prevIter.length);

    }
  }, [hotoDetails])

  useEffect(() => {
    if (allMaterialList !== undefined) {
      setMaterialList(allMaterialList);
    }
  }, [allMaterialList])

  useEffect(() => {
    (async () => await getHotoMaterialList(match.params.team, match.params.id))();
  }, [getHotoMaterialList]);

  useEffect(() => {
    (async () => await getMaterial())();
  }, [getMaterial]);

  // handle input change
  const handleInputChange = (value, index, field_name) => {
    const list = [...inputList];
    list[index][field_name] = value;
    setInputList(list);
  };
  const handledropDownChange = (e, index, name) => {
    const {value, id} = e;
    const list = [...inputList];
    list[index][name] = id;
    setInputList(list);
  };

  const handleImageChange = (index, val, name) => {
    const list = [...inputList];
    list[index][name] = val;
    setInputList(list);
  };

  const handleModalHide = async () => {
    setIsModal(false);
    history.push(`${baseUrl}/hoto-msite-listing/2`);
  };

  const handleMaterialModalHide = async () => {
    setAddMaterialModal(false);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index,imgIndex) => {
    const list = [...inputList];
    const imageList = list[index]['m_image'];
    imageList.splice(imgIndex, 1);
    list[index]['m_image'] = imageList;
    setInputList(list);
  };
  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, {material_id: "",material_name: "", m_remarks: "", m_mat_status: "", m_image: []}]);
  };

  const addMaterial = () => {
    if (newMaterial !== '') {
      setInputList([...inputList, newMaterial]);
      setAddMaterialModal(false);
      setNewMaterial('');
    }
  };

  const removeMaterial = (id) => {
    if (id) {
      const list = [...inputList];
      list.splice(id, 1);
      setInputList(list);
    }
  };

  const handleSubmit = (team, hoto_id) => {
    let isNotEmpty = true;
    let vali = true;
    {inputList.map((x, i) => {
      console.log(x);
       if (x.m_image ==  "" || x.m_mat_status == "" || x.m_remarks == "" || x.material_id == "") {
        isNotEmpty = false;
       }

    })}
    if (isNotEmpty !== false) {
      (async () => {
        setIsLoading(true);
        var obj = {hoto_data: inputList,
          hoto_id: hoto_id,
          team: team
        };
        const res = await saveHotoMaintenance(obj);
        if (res) {
          setMessage('Details saved successfully!');
          setIsModal(true);
        } else {
          setMessage('Not Saved!');
          setIsModal(true);
        }
        setIsLoading(false);
      })();
    } else {
      const active = document.querySelector('.activeAnkInput');
      if(active){
        active.focus();
      }else{
        toast.error('Please fill all the fields & upload all images.');
      }
    }
  };

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(match.params.team, match.params.id)} /* disabled={isClicked} */>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight}/>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      title={localization.goBack}
    >
      <FormSection title={localization.hotoForm}>

        {inputList.map((x, i) => {
          return (
            <CardSection title={x.material_name}
              remove={x?.is_new == true && true}
                  removeIt={(val) => {
                  if (val) {
                    removeMaterial(i);
                  }
                }}
              >
            <div key={i} className="row">
              <div className="col-md-3">
                <DropDownInput
                  label={localization.status}
                  data={[
                    {id: 'OK', name: 'OK'},
                    {id: 'NOT OK', name: 'NOT OK'},
                  ]}
                  required
                  isStarRequired={true}
                  errorMsg={localization.status}
                  getIdValue={(val) => {
                    handledropDownChange(val, i, 'm_mat_status');
                  }
                  }
                  value={x.status}
                />

              </div>
              <div className="col-md-3">
                <ConstantInput
                  label={'Remarks'}
                  type="text"
                  required
                  isStarRequired={true}
                  handleChange={value => handleInputChange(value, i, 'm_remarks')}
                  value={x.m_remarks}
                />
              </div>
              <div>
                <FileUpload
                  id={"agreementContractUpload" + i}
                  accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                  documentUploadUrl={imageUploadUrlPublic}
                  onChange={(val) => handleImageChange(i, val, 'm_image')}
                  showFileName={false}
                  multiple={true}
                >
              <span className="btn btn-transparent">
                {localization.image}
                <span className="label-star" style={{color: 'red'}}>
                  &nbsp; *
                </span>
              </span>
                </FileUpload>
              </div>
              {x?.m_image &&
                <>
                <div class="row img-div">
                  {x.m_image.map((imgdoc, j) => {
                    return (
                      <>
                      <div className="col-md-2">
                        {
                          imgdoc.split('.').pop() == 'png' ?
                            <img src={imgdoc} style={{
                              "width": "80px",
                              "borderRadius": "16px",
                              "height": "57px"
                            }}/>
                            :
                            imgdoc.split('.').pop() === 'jpeg' ? <img src={imgdoc}
                                                                      style={{
                                                                        "width": "80px",
                                                                        "borderRadius": "16px",
                                                                        "height": "57px"
                                                                      }}/> :
                              imgdoc.split('.').pop() === 'jpg' ? <img src={imgdoc}
                                                                       style={{
                                                                         "width": "80px",
                                                                         "borderRadius": "16px",
                                                                         "height": "57px"
                                                                       }}/> :
                                imgdoc.split('.').pop() === 'pdf' ?
                                  <img src={Images?.DocIcon} alt=""
                                       className="view-icon"/> :
                                  imgdoc.split('.').pop() === 'doc' ?
                                    <img src={Images?.DocIcon} alt=""
                                         className="view-icon"/> :
                                    imgdoc.split('.').pop() === 'mp4' ?
                                      <video width="120" height="80" controls>
                                        <source src={imgdoc}
                                                type="video/mp4"></source>
                                      </video> :
                                      imgdoc.split('.').pop() === 'webm' ?
                                        <video width="120" height="80"
                                               controls>
                                          <source src={imgdoc}
                                                  type="video/mp4"></source>
                                        </video> :
                                        imgdoc.split('.').pop() === 'mkv' ?
                                          <video width="120" height="80"
                                                 controls>
                                            <source src={imgdoc}
                                                    type="video/mp4"></source>
                                          </video> :
                                          ""
                        }
                        <a className='remover' onClick={() => handleRemoveClick(i,j)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
                         <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                         <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                        </a>
                      </div>
                      </>
                    );
                  })}

                  </div>
                </>
              }
            </div>
            </CardSection>
          );
        })}
        <div className="d-inline-block Gate-check-btn">
          <Button
            onClick={() => setAddMaterialModal(true)}
            className="btn btn-transparent"
          >
            {localization.addMaterial}
          </Button>
        </div>
      </FormSection>
      <br/>
      {/*Previous Hoto Iterations Start*/}
      {
        previousIter &&
        <div className="container-fluid mb-0">
          {previousIter.map((prevIt, key2) => {
            return(
              <div className="card mb-2">
                <div className="card-header mb-3">
                  HOTO Iteration {iterCount-key2}
                  <span className='r-shiwt'>
                  ME: <b>{prevIt?.[0].m_name} ({prevIt?.[0].me_created_at})</b>
                </span>
                  <span className='r-shiwt m-right'>
                  SE: <b>{prevIt?.[0].i_name} ({prevIt?.[0].se_updated_at})</b>
                </span>
                </div>
                <div className="card-body ml-2 mr-2">

                  <table className='panel-table table table-striped mb-2' width="100%">
                    <thead>
                    <tr>
                      <th> Material</th>
                      <th> Maintenance Images</th>
                      <th> Material Status</th>
                      <th> Maintenance Remark</th>
                      <th> Operation Images</th>
                      <th> Operation Remark</th>
                    </tr>
                    </thead>
                    <tbody>
                    {prevIt.map((value, key3) => {
                      // {console.log(value)}
                      return (
                        <tr key={key3}>
                          <td>{value.material_name}</td>
                          <td>
                            {value?.m_image &&
                              <div className='scrollable-img'>
                                {value.m_image.map((imgdoc, j) => {
                                  return (
                                    <a href={imgdoc} target='_blank'>
                                      {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                   style={{
                                                                                     "width": "80px",
                                                                                     "borderRadius": "8px",
                                                                                     "height": "57px",
                                                                                     "border": "1px solid #555"
                                                                                   }}/> <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'jpeg' ? <>  <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'pdf' ?
                                              <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                              imgdoc.split('.').pop() === 'doc' ?
                                                <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                ""
                                      }
                                    </a>
                                  );
                                })}
                              </div>
                            }
                          </td>
                          <td>{value?.m_mat_status}</td>
                          <td>{value?.m_remarks}</td>
                          <td>{value?.ins_remarks}</td>
                          <td>
                            {value?.ins_image &&
                              <>
                                <div className='scrollable-img'>
                                  {value.ins_image.map((imgdoc, j) => {
                                    return (
                                      <a href={imgdoc} target='_blank'>
                                        {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                     style={{
                                                                                       "width": "80px",
                                                                                       "borderRadius": "8px",
                                                                                       "height": "57px",
                                                                                       "border": "1px solid #555"
                                                                                     }}/>  <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                       style={{
                                                                                         "width": "80px",
                                                                                         "borderRadius": "8px",
                                                                                         "height": "57px",
                                                                                         "border": "1px solid #555"
                                                                                       }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                        style={{
                                                                                          "width": "80px",
                                                                                          "borderRadius": "8px",
                                                                                          "height": "57px",
                                                                                          "border": "1px solid #555"
                                                                                        }}/> <span className="space"></span> </> :
                                              imgdoc.split('.').pop() === 'pdf' ? <>
                                                  <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                imgdoc.split('.').pop() === 'doc' ? <>
                                                    <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                                  ""
                                        }
                                      </a>
                                    );
                                  })}
                                </div>
                              </>
                            }
                          </td>

                        </tr>
                      );

                    })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      }

      {/*Previos Hoto Iterations End*/}

      {/*Add new material modal*/}
      <ModalPop
        title={localization.addMaterial}
        show={addMaterialModal}
        handleModalHide={handleMaterialModalHide}
        keyboard
        backdrop
        isLoading={isLoading}
      >
        <div className="text-center">
          <DropDownInput
                label={localization.product}
                required
                isStarRequired={true}
                data={materialList}
                errorMsg={localization.isRequired}
                getIdValue={(val) => {
                  if (val.id !== '') {
                    setNewMaterial({
                      material_id: val.id,
                      material_name: val.value,
                      m_remarks: "", m_mat_status: "", m_image: [],
                      is_new: true
                    });
                  }
                }}
          />
          <Button
            className="btn btn-primary mb-4"
            onClick={() => addMaterial()}
          >
            {localization.addMaterial}
          </Button>
        </div>
      </ModalPop>


      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{modalMsg}</h5>
          <Link
            to={`${baseUrl}/hoto-msite-listing/2`}
            className="btn btn-primary mb-4"
          >
            Go to Listing <img src={Images?.ArrowRight} alt="" />
          </Link>

        </div>
      </ModalPop>

    </Layout>
  );
};
HotoMainForm.propTypes = {
  data: PropTypes.any,
  history: propTypes.any,
};
export default HotoMainForm;
